<template>
	<el-dialog :visible.sync="is_visible" :width="'40%'" @close="close" :modal="false">
		<template slot="title">
			<div>
				<h3 class="mb-0 font-weight-500">Change {{ this.form.user_type }}</h3>
			</div>
		</template>
		<b-form role="form">
			<b-row>
				<b-col cols="12">
					<b-form-group :label="'Select New '+this.form.user_type+' User'">
						<el-select v-model="form.user_id" placeholder="Select" @change="setUserName($event)">
							<el-option :label="'No Selected'" :value="null"></el-option>
							<el-option v-for="(item,index) in userList" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12" class="text-center">
					<el-button class="bg-primary text-white w-100" @click.prevent="submit()" :loading="is_loading_btn">Update</el-button>
				</b-col>
			</b-row>
		</b-form>
	</el-dialog>
</template>
<script>
import { Button, Dialog, Select, Option } from 'element-ui'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useAccessControlStore } from '@/stores/accessControlStore';

export default {
	components: {
		[Button.name]: Button,
		[Dialog.name]: Dialog,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
			return {
				loanEc:{},
				is_visible: false,
				is_loading_btn: false,
				form:{
					user_id:null,
					user_name:null,
					user_type:null,
				}
			}
	},
	computed: {
		...mapState(useCustomerStore, ['activeLoanEC']),
		...mapState(useAccessControlStore, ['userList']),
	},
	watch: {
		activeLoanEC: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.loanEc = newVal
				}
			}
		},
	},
	methods: {
		...mapActions(useCustomerStore, ['updateLoanEC']),
		show(type,curr_id=null) {
			this.form.user_type = type;
			this.form.user_id = curr_id;
			this.is_visible = true
		},
		setUserName(value){
			const user = this.userList.find(itm => itm.id == value);
			this.form.user_name = _gHlp.getValue(user, 'name');
		},
		submit(){
			this.is_loading_btn = true;
			let params = {};
			switch (this.form.user_type) {
				case 'Officer':{
					params = {
						loan_officer_id: this.form.user_id,
						loan_officer_name: this.form.user_name,
					}
					break;
				}
				case 'Credit Manager':{
					params = {
						credit_manager_id: this.form.user_id,
						credit_manager_name: this.form.user_name,
					}
					break;
				}
				default:
					break;
			}	
			if(!_gHlp.isEmpty(params)){
				this.updateLoanEC(params,this.loanEc.loan_ec_id).then(resp => {
					_gNotif.notifySuccess(this.form.user_type + " has been update",10000,'success')
					this.close();
				}).catch(err => {
					this.close();
				})
			}else{
				this.close()
			}
		},
		close(){
			this.is_visible = false
			this.is_loading_btn = false
			this.form = {
				user_id:null,
				user_name:null,
				user_type:null,
			}
		}
	},
}
</script>